var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0335 17.29C28.1635 17.72 28.5634 18 28.9933 18V17.99C29.0933 17.99 29.1832 17.98 29.2832 17.95C29.8131 17.79 30.113 17.24 29.9531 16.71C29.9231 16.61 26.6138 6 15.9961 6C5.3784 6 2.06911 16.61 2.03912 16.72C1.87915 17.25 2.17909 17.8 2.70897 17.96C3.23886 18.12 3.79874 17.82 3.9587 17.29C4.06868 16.91 6.88807 8 15.9961 8C25.1005 8 27.9114 16.9033 28.0335 17.29ZM12 18C12 15.7909 13.7909 14 16 14C18.2091 14 20 15.7909 20 18C20 20.2091 18.2091 22 16 22C13.7909 22 12 20.2091 12 18ZM16 12C12.6863 12 10 14.6863 10 18C10 21.3137 12.6863 24 16 24C19.3137 24 22 21.3137 22 18C22 14.6863 19.3137 12 16 12Z",
    fill: "#131542"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVision);
export default __webpack_public_path__ + "static/media/vision.aed6dbd08d5a47de1c4f6f220c68c861.svg";
export { ForwardRef as ReactComponent };